var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Row",
    { staticClass: "deviceConfig no-cancel-tree" },
    [
      _c(
        "i-col",
        { staticClass: "left-box", attrs: { span: "9" } },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("deviceSip.area")))]),
          _c("config-tree", {
            key: _vm.timeStamp,
            ref: "configTree",
            attrs: {
              "current-step": _vm.currentStep,
              "current-chosen-node": _vm.currentNode["$treeNodeId"],
            },
            on: { selectTree: _vm.selectTree },
          }),
        ],
        1
      ),
      _c(
        "i-col",
        { staticClass: "right-box forbit-cancel-tree", attrs: { span: "14" } },
        [
          _c(
            "div",
            { staticClass: "fun-box" },
            [
              _c(
                "Button",
                {
                  staticClass: "pro-edit-color forbit-cancel-tree",
                  attrs: { icon: "md-checkbox-outline", size: "large" },
                  on: {
                    click: function ($event) {
                      return _vm.showAddAreaDeviceModal(false, 1)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("deviceSip.editDevice")) + " ")]
              ),
              _c(
                "Button",
                {
                  staticClass: "pro-add-color forbit-cancel-tree",
                  attrs: { icon: "md-add-circle", size: "large" },
                  on: {
                    click: function ($event) {
                      return _vm.showAddAreaDeviceModal(false, 0)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("deviceSip.addDevice")) + " ")]
              ),
              _c(
                "Button",
                {
                  staticClass: "pro-batch-color forbit-cancel-tree",
                  attrs: { icon: "md-albums", size: "large" },
                  on: {
                    click: function ($event) {
                      return _vm.showAddAreaDeviceModal(true, 0)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("deviceSip.batchDevice")) + " ")]
              ),
              _c(
                "Button",
                {
                  staticClass: "pro-del-color forbit-cancel-tree",
                  attrs: { icon: "ios-trash", size: "large" },
                  on: { click: _vm.showDelDeviceModal },
                },
                [_vm._v(" " + _vm._s(_vm.$t("deviceSip.delDevice")) + " ")]
              ),
            ],
            1
          ),
          _c("device-msg", {
            key: _vm.timeStamp,
            attrs: { "current-node": _vm.currentNode },
          }),
        ],
        1
      ),
      _c(
        "i-col",
        { staticClass: "footer-btn forbit-cancel-tree", attrs: { span: "24" } },
        [
          _c(
            "Button",
            {
              attrs: { type: "primary", ghost: "", size: "large" },
              on: { click: _vm.setCurrentStep },
            },
            [_vm._v(" " + _vm._s(_vm.$t("deviceSip.prev")) + " ")]
          ),
          _c(
            "Button",
            {
              attrs: { type: "primary", size: "large" },
              on: { click: _vm.checkFileStream },
            },
            [_vm._v(" " + _vm._s(_vm.$t("deviceSip.exportAddr")) + " ")]
          ),
        ],
        1
      ),
      _c("add-device-modal", {
        ref: "addDeviceModal",
        attrs: {
          "is-batch-device": _vm.isBatchDevice,
          "device-type": _vm.deviceType,
          "current-node": _vm.currentNode,
        },
        on: { updateTree: _vm.updateTree, updateMsg: _vm.updateMsg },
      }),
      _c("add-batch-device-modal", {
        ref: "addBatchDeviceModal",
        attrs: {
          "current-node": _vm.currentNode,
          "area-type-name-list": _vm.areaTypeNameList,
        },
        on: { updateTree: _vm.updateTree },
      }),
      _c(
        "confirmModal",
        { ref: "confirmModal", on: { afterComfirm: _vm.delDevice } },
        [
          _c("div", { attrs: { slot: "info" }, slot: "info" }, [
            _c("p", { staticClass: "p-text" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("deviceSip.deleteTip")) +
                  "“" +
                  _vm._s(_vm.currentNode.name) +
                  "”? "
              ),
            ]),
          ]),
        ]
      ),
      _c("modal", {
        ref: "resultModal",
        attrs: { type: _vm.modalType },
        on: { afterComfirm: _vm.backBtn },
      }),
      _c("submit-error-modal", {
        ref: "submitErrorModal",
        on: { updateTree: _vm.updateTree },
      }),
      _c("export-modal", {
        ref: "exportModal",
        on: { updateTree: _vm.updateTree },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }